import { useNavigate } from "react-router-dom";
import * as React from "react";
import SingleSelectKendoGrid from "../../Grid/Selectable/SingleSelectKendoGrid";
import { OdcGridColumns } from "./OdcGridColumns";
import OdcOverviewItem from "./OdcOverviewItem";
import { combinedUrls } from "../../URL/functions";
import { odcUrls } from "../../URL/ApplicationUrls";
import PageHeader from "../../Layout/Header/PageHeader";
import { defaultAddButton } from "../../Grid/Toolbar/DefaultAddButton";
import { defaultEditButton } from "../../Grid/Toolbar/DefaultEditButton";
import { odcTypeAsString } from "../OdcType";
import { createExportButton } from "../../Grid/ExcelExport/CreateExportButton";
import { AuthorizationPolicies } from "../../Auth/AuthorizationPolicy";

export default function OdcOverview() {
  const navigate = useNavigate();

  const addOdc = () => navigate(odcUrls.addOdc.uiPath);

  const editOdc = (odc: OdcOverviewItem | undefined) =>
    odc && navigate(odcUrls.editOdc(odc.Id).uiPath);

  const url = combinedUrls(odcUrls.base.apiUrl, "KendoGrid");

  return (
    <>
      <PageHeader headerText="ODC & Other" />
      <SingleSelectKendoGrid
        localStorageKey="OdcOverviewGrid_DataState"
        fetchUrl={url}
        columns={OdcGridColumns()}
        idSelector={(odc: OdcOverviewItem) => odc.Id}
        toolbarItems={[
          defaultAddButton({
            onClick: addOdc,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
          defaultEditButton({
            onClick: editOdc,
            roles: AuthorizationPolicies.RequireAdminNetworkRoles,
          }),
        ]}
        onRowDoubleClick={editOdc}
        customToolbarItems={[
          createExportButton({
            url,
            filename: "ODCs",
            mapping: (odc: OdcOverviewItem) => ({
              ...odc,
              Type: odcTypeAsString.get(odc.Type),
            }),
          }),
        ]}
      />
    </>
  );
}
